module.exports = __webpack_public_path__ + "img/search-white.6c2a8ea4.svg";